import rnSession from 'rhino/src/components/session/session.module.js';
import * as rnUser from './user.service.js';

export default angular.module('rhino.components.user', [rnSession])
  .factory(rnUser.name, rnUser.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/user/user.module.js